import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import mvtBreadcrumb from '@/common/components/mvtbreadcrumb/mvt-breadcrumb.vue';
import lazyCarouselCheckMixin from '@/common/mixins/lazycarouselcheck';
import dspMap from '@/dsp/components/dspmap/dsp-map.vue';
import dspMarket from '@/dsp/components/dspmarket/dsp-market.vue';
import dspNearbySchool from '@/dsp/components/dspnearbyschool/dsp-nearbyschool.vue';
import dspRecord from '@/dsp/components/dsprecord/dsp-record.vue';
import dspReview from '@/dsp/components/dspreview/dsp-review.vue';
import dspScore from '@/dsp/components/dspscore/dsp-score.vue';
import dspTitle from '@/dsp/components/dsptitle/dsp-title.vue';
import mvtSeoLink from '@/common/components/mvtseolink/mvt-seolink.vue';
import { mapGetters } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';
import mvtListProperty from '@/common/components/mvtlistproperty/mvt-listproperty.vue';

export default {
    name: 'pageDsp',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dsp', ['dsp']),
        hasSeoLinks() {
            return (
                (this.dsp.seoNearbyCities && this.dsp.seoNearbyCities.length) ||
                (this.dsp.seoNearbyZipCode && this.dsp.seoNearbyZipCode.length) ||
                (this.dsp.seoNearbyneighborhood && this.dsp.seoNearbyneighborhood.length) ||
                (this.dsp.seoNearbyCounties && this.dsp.seoNearbyCounties.length)
            );
        },
    },
    components: {
        mvtPopSignin,
        mvtDialogCenter,
        mvtNearby,
        mvtBreadcrumb,
        dspTitle,
        dspRecord,
        dspMap,
        dspReview,
        dspNearbySchool,
        dspScore,
        dspMarket,
        mvtSeoLink,
        mvtHeader,
        mvtFooter,
        mvtLazyload,
        mvtListProperty,
    },
    mixins: [lazyCarouselCheckMixin],
    methods: {
        completedOpen() {
            this.$refs.lazyloadOpen.ready();
        },
        completedNew() {
            this.$refs.lazyloadNew.ready();
        },
        greatSchoolReviewUrl(){
            let externalUrl = this.dsp.externalUrls && this.dsp.externalUrls.filter(item => item.type === 'Parent Reviews');
            return externalUrl && externalUrl.length ? externalUrl[0].url : '' ;
        }
    },
    mounted() {
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
};
